import React, { useContext } from 'react';
import './RelatedProducts.css';
import { ShopContext } from '../../Context/ShopContext';
import Item from '../Items/Item';

const RelatedProducts = ({ currentProduct }) => {
  // Move Hook call to the top of the component
  const { all_products } = useContext(ShopContext);

  // Perform conditional checks after all Hooks have been called
  if (!currentProduct) {
    return null;
  }

  const related = all_products.filter(item => 
    item.category === currentProduct.category && item.id !== currentProduct.id
  ).slice(0, 4);

  if (related.length === 0) {
    return null;
  }

  return (
    <div className='relatedproducts'> 
      <h2>Related Products</h2>
      <hr />
      <div className="relatedP-items">
        {related.map((item) => (
          <Item 
            key={item.id} 
            id={item.id}  
            name={item.name} 
            info={item.info} 
            image={item.image}  
            newPrice={item.newPrice}  
            oldPrice={item.oldPrice}
          />
        ))}
      </div>
    </div>
  );
};

export default RelatedProducts;